import Swal from 'sweetalert2';
import { useContext } from 'react';
import { AuthContext, useNavigate } from 'components/lib';

/**
 * useFeatureCheck Hook
 * 
 * Provides a functional way to check if a feature is allowed in the current plan.
 * 
 * @returns {function} checkFeature - Function that takes (feature, onPass)
 */
const useFeatureCheck = () => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  /**
   * checkFeature
   * 
   * @param {string} feature - The feature key to check in activePlan (e.g., 'customDashboardAllowed')
   * @param {function} onPass - Callback to execute if the feature is allowed
   */
  const checkFeature = (feature, onPass) => {
    if (authContext.activePlan?.[feature] === undefined || authContext.activePlan?.[feature]) {
      if (onPass) onPass();
      return true;
    } else {
      Swal.fire({
        icon: 'info',
        title: 'Upgrade to Access',
        html: 'Your current plan does not allow you to do this.',
        showCancelButton: true,
        confirmButtonText: 'Upgrade',
        confirmButtonColor: '#0066FF',
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/account/billing');
        }
      });
      return false;
    }
  };

  return checkFeature;
};

export default useFeatureCheck;
